import { render, staticRenderFns } from "./tab-item.vue?vue&type=template&id=02ac1140&scoped=true&"
import script from "./tab-item.vue?vue&type=script&lang=js&"
export * from "./tab-item.vue?vue&type=script&lang=js&"
import style0 from "./tab-item.vue?vue&type=style&index=0&id=02ac1140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ac1140",
  null
  
)

export default component.exports